import { HttpBackend, HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { ErrorSummary } from '@career/core/models/error.model';
import { environment } from 'projects/pocket-career/src/environments/environment';
import { Observable } from 'rxjs';

export interface AdminHandoff { code: string; }

export function captureAdminHandoff(location: Location, history: History): AdminHandoff | null {
  const fragment = new URLSearchParams(location.hash.slice(1));
  if (location.pathname !== '/admin/login' || !fragment.has('adminSso')) return null;
  const code = fragment.get('adminSso');
  // Run before Angular/NGXS/router/analytics initialization; never retain the code in a URL.
  history.replaceState(history.state, '', location.pathname + location.search);
  return { code };
}

let pendingHandoff = captureAdminHandoff(window.location, window.history);
export const ADMIN_HANDOFF = new InjectionToken<AdminHandoff | null>('Admin sign-on handoff', {
  providedIn: 'root',
  factory: () => {
    const handoff = pendingHandoff;
    pendingHandoff = null;
    return handoff;
  }
});

@Injectable({ providedIn: 'root' })
export class AdminSignOnService {
  readonly attempted: boolean;
  completed = false;
  error: ErrorSummary;
  private readonly http: HttpClient;

  constructor(backend: HttpBackend, @Inject(ADMIN_HANDOFF) private handoff: AdminHandoff | null) {
    // An older portal token or audit identity must not be attached to the exchange.
    this.http = new HttpClient(backend);
    this.attempted = handoff !== null;
  }

  exchange(): Observable<HttpResponse<any>> {
    const portalUrl = environment['testAccount'] || window.location.hostname.split('.')[0];
    const code = this.handoff.code;
    this.handoff = null;
    return this.http.post(`/api/agency/portal/${encodeURIComponent(portalUrl)}/admin-sso/exchange`,
      { code }, { observe: 'response' });
  }

  fail(error: { status?: number }): void {
    this.completed = false;
    this.error = new ErrorSummary(error?.status === 403
      ? 'Your Kleos account cannot administer this portal.'
      : 'Unable to sign in from Kleos. Open the Admin link again from Kleos, or sign in below.');
  }
}
